import { useT } from '@clara/locale'

export const getErrorHelperText = (
  t: ReturnType<typeof useT>['t'],
  error: any,
) => {
  if (error) {
    return t(
      (error as unknown as any).message.key || (error?.message as string),
      {
        ...(error as unknown as any).message.values,
        ns: 'reimbursements',
      },
    )
  }
}
